import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { msrGray16, msrBlue16, msrGreen16 } from 'assets/msrIcons';

// const MarkerWithLabelIcon = ({ isSelected, label, isHovered, isSubject, isSelectedAsComp, marker, selectedMarkerImages, isFetchingImages, images, setMarkerLabelHeight }) => {
const MarkerWithLabelIcon = ({ isSelected, label, isHovered, isSubject, isSelectedAsComp, isTerminated, selectionEnabled, uwType, id, iconColor, iconType }) => {
  // const ref = useRef(null);
  // useEffect(() => {
  // // Get the label size after it renders and pass it back to parent
  //   if (ref && ref.current) {
  //     setMarkerLabelHeight(ref.current.clientHeight);
  //   }
  // });
  // console.log(label);
  // console.log(selectedMarkerImages);
  // console.log(isFetchingImages);
  // console.log(marker);
  // console.log(images);
  // console.log(images.hasOwnProperty(marker.id));
  const styles = {
    checkbox: {
      width: 15,
      height: 15,
      cursor: 'pointer'
    },
    label: {
      color: 'black'
    },
    iconPrimary: {
      fontSize: '1.75rem'
    },
    iconSecondary: {
      fontSize: '1.25rem'
    },
    textSecondary: {
      fontSize: '0.8em',
    }
  }
  // let additionalTextArr = [];
  // if (marker.beds) {
  //   additionalTextArr.push(`${(marker.beds).toFixed(1)} bd`);
  // };
  // if (marker.baths) {
  //   additionalTextArr.push(`${(marker.baths).toFixed(1)} ba`);
  // }
  // if (marker.sqft) {
  //   additionalTextArr.push(`${(marker.sqft).toLocaleString()} sqft`);
  // }
  // const additionalText = additionalTextArr.join(' / ');
  // const labelText = isHovered ?
  //   <div style={styles.label}>
  //     <div><b>{marker.streetAddress || marker.street}, {marker.city}, {marker.state}, {marker.zipCode || marker.zipcode}</b></div>
  //     {marker.price &&
  //       <div>
  //         <b>Rent: ${marker.price.toLocaleString()} </b>
  //         <span style={styles.textSecondary}>(${(marker.price / marker.sqft).toFixed(2)} per sqft)</span>
  //       </div>
  //     }
  //     <div>
  //       {additionalText}
  //     </div>
  //     <div>
  //       {images.hasOwnProperty(marker.id) ?
  //         (isFetchingImages ?
  //           <div style={styles.center}>Loading...</div>
  //           :
  //           selectedMarkerImages.length > 0 ?
  //             <div style={styles.imagesContainer}>
  //               {selectedMarkerImages.map((item, index) => (
  //                 <img key={index}
  //                   style={styles.image}
  //                   // src={item.url}
  //                   src={item}
  //                   // src={`https://uat-m3portal.amherstresidential.com${i.url}`}
  //                   width='41'
  //                   height='41'
  //                 // onMouseEnter={e => setSelectedImage(item)}
  //                 // onMouseLeave={e => setSelectedImage(null)}
  //                 />
  //               ))}
  //             </div>
  //             :
  //             <div style={styles.center}>There are no images</div>
  //         )
  //         : <div>Click to fetch images</div>
  //       }
  //     </div>
  //   </div> :
  //   <span style={styles.label}>{label}</span>

  let auctionClasses = isTerminated ? 'terminated' : '';
  const onChange = () => { };
  const getIcon = () => {
    let getMsrImage = () => {
      if (iconColor === 'blue') {
        return msrBlue16;
      } else if (iconColor === 'grey') {
        return msrGray16;
      } else if (iconColor === 'green') {
        return msrGreen16;
      }
    }
    if (iconType === "house") {
      return (<SvgIcon style={(isSubject ? styles.iconPrimary : styles.iconSecondary)}>
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" stroke='#000' strokeWidth='1' />
      </SvgIcon>);
    } else if (iconType === "msr") {
      return (<img alt='msrIcon' src={getMsrImage()} style={{ padding: 2 }}></img>);
    }
  }

  return (
    <div className={`markerWithLabel ${isSelected ? 'selectedMarker' : ''} ${isSelectedAsComp ? 'selectedComp' : ''} ${auctionClasses}`} data-id={id}>
      {/* <div className={`markerWithLabel ${isSelected ? 'selectedMarker' : ''}`} ref={ref}> */}
      {/* style={(selected ? styles.selected : styles.comp)}> */}
      {
        uwType !== 'auctionUW' && isHovered && !isSubject && selectionEnabled ?

          <input type='checkbox' onChange={onChange /* an onChange prop is required when using checked */}
            checked={isSelectedAsComp} style={styles.checkbox} /> :

          <span style={{ color: iconColor }}>
            {getIcon()}
          </span>
      }
      <span style={styles.label}>{label}</span>
      {/* {labelText} */}
      {/* {label} */}
    </div>
  )
}

export default MarkerWithLabelIcon;